import { ReactElement } from "react";
import { ORDER_BUYER } from "../../../../../../../constants/routes";
import { useNavigateToChild } from "../../../../../../../hooks/useParentNavigation";
import { formatCurrency } from "@sellar-io/common";
import { BadgeGreen } from "../../../../../../../components/badge/Badge";
import { ProgressBarGreen } from "../../../../../../../components/progressBar/ProgressBar";
import { Icon } from "../../../../../../../components";

const SubtotalFreeDeliveryProgress = ({
  freeDeliveryRemainder,
  freeDeliveryThreshold,
  onClick,
}: {
  freeDeliveryRemainder: number;
  freeDeliveryThreshold: number;
  onClick: () => void;
}) => {
  const percentageComplete = Math.max(
    Math.floor(
      ((freeDeliveryThreshold - freeDeliveryRemainder) /
        freeDeliveryThreshold) *
        100,
    ),
    1,
  );
  const formattedFreeDeliveryRemainder = formatCurrency(freeDeliveryRemainder);

  return (
    <div
      className="grid cursor-pointer grid-cols-5 items-center gap-2 rounded-lg border border-solid border-emerald-300 bg-emerald-100 p-2 text-emerald-800"
      onClick={onClick}
    >
      <div className="col-span-5 flex items-center gap-2 md:col-span-3">
        <BadgeGreen icon={"TRUCK"} />
        <div>
          Spend{" "}
          <span className="font-bold">
            {formattedFreeDeliveryRemainder} more
          </span>{" "}
          for free delivery
        </div>
      </div>

      <div className="col-span-5 flex items-center gap-2 md:col-span-2">
        <ProgressBarGreen percentage={percentageComplete} />
        <Icon icon={"CHEVRON_RIGHT"} size={1} />
      </div>
    </div>
  );
};

export const DeliveryDiscountDraftBasket = ({
  subtotalFreeDeliveryThreshold,
  subtotal,
  supplierUrlId,
}: {
  subtotalFreeDeliveryThreshold: number;
  subtotal: number;
  supplierUrlId: string;
}): ReactElement | null => {
  const navigateToChild = useNavigateToChild();
  const freeDeliveryRemainder = subtotalFreeDeliveryThreshold - subtotal;
  const orderQualifiesForFreeDelivery = freeDeliveryRemainder <= 0;

  if (orderQualifiesForFreeDelivery) {
    return null;
  }

  return (
    <SubtotalFreeDeliveryProgress
      freeDeliveryRemainder={freeDeliveryRemainder}
      freeDeliveryThreshold={subtotalFreeDeliveryThreshold}
      onClick={() =>
        navigateToChild(ORDER_BUYER.href({ supplierIdOrUrlId: supplierUrlId }))
      }
    />
  );
};
